import { talentoApi } from './index';

const hiringApiExtension = talentoApi.injectEndpoints({
  endpoints: (builder) => ({
    sendSurveyToUser: builder.mutation<void, { email: string }>({
      query: ({ email }) => ({
        url: `/hubspot/survey/send?email=${email}`,
        method: 'POST',
      }),
    }),
    getCountryController: builder.query<
      {
        departmentList: string;
        cityList: string;
      },
      string
    >({
      query: (countryCode) => ({
        url: `/hiring/countries`,
        method: 'GET',
        params: {
          code: countryCode,
        },
      }),
    }),
    getDecryptedFile: builder.mutation<{ file: string }, { email: string; file: string }>({
      query: ({ email, file }) => ({
        url: `/hiring/documents/process`,
        method: 'POST',
        body: {
          email,
          file,
        },
      }),
    }),
    getProfilePhoto: builder.query<string, void>({
      query: () => ({
        url: `/hiring/photo`,
        method: 'GET',
        responseHandler: 'text',
      }),
    }),
    saveProfilePhoto: builder.mutation<void, { email: string; photo: string }>({
      query: ({ email, photo }) => ({
        url: `/hiring/photo`,
        method: 'POST',
        body: {
          email,
          photo,
        },
      }),
    }),
    deleteProfilePhoto: builder.mutation<void, void>({
      query: () => ({
        url: `/hiring/photo`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useSendSurveyToUserMutation,
  useGetCountryControllerQuery,
  useGetDecryptedFileMutation,
  useLazyGetProfilePhotoQuery,
  useGetProfilePhotoQuery,
  useSaveProfilePhotoMutation,
  useDeleteProfilePhotoMutation,
} = hiringApiExtension;
